import {
  get,
  post,
} from '@/utils/request';

const url = 'voucher-add-records';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}
